<template>
  <div class="container-fluid">
    <!-- Bread-crumb-->
    <div class="block-header">
      <bread-crumb></bread-crumb>
    </div>
    <div class="row clearfix">
      <div class="col-lg-12">
        <div class="card card-top-line">
          <!-- Header -->
          <div class="header d-flex justify-content-between align-items-center">
            <h2>Receivers Blacklist</h2>
          </div>
          <div class="body pt-0">
            <div class="d-md-flex justify-content-between align-items-center">
              <div class="from-group w-100 mr-2 mb-md-0 mb-2">
                <span class="float-label">
                  <input
                    type="text"
                    class="form-control"
                    id="search"
                    v-model="searchReceivers"
                    @keyup="!searchReceivers ? (displaySenders = false) : ''"
                    placeholder="Search with receivers Account no. or Mobile no.*"
                  />
                  <label class="control-label" for="search">
                    Search receivers
                  </label>
                  <div class="line"></div>
                </span>
              </div>
              <b-button
                class="btn btn-auto"
                variant="outline-primary"
                @click="search()"
              >
                Search Receivers
              </b-button>
            </div>
            <span class="text-muted mb-3">
              Search with receivers Account Number or Mobile Number
            </span>
            <div v-if="displaySenders">
              <h5 class="text-primary font-weight-normal mt-1">
                Receivers Details
              </h5>
              <div class="row">
                <div class="col-xl-4 col-md-6">
                  <ul class="list-unstyled mb-0 striped-list">
                    <li>
                      <div class="row">
                        <div class="col-md-5">
                          <strong class="p-2 d-inline-block">Name:</strong>
                        </div>
                        <div class="col-md-7">
                          <span class="p-2 d-inline-block">Sam Witwicky</span>
                        </div>
                      </div>
                    </li>
                    <li>
                      <div class="row">
                        <div class="col-md-5">
                          <strong class="p-2 d-inline-block">Gender:</strong>
                        </div>
                        <div class="col-md-7 d-flex">
                          <span class="p-2 d-inline-block">Male</span>
                        </div>
                      </div>
                    </li>
                  </ul>
                </div>
                <div class="col-xl-4 col-md-6">
                  <ul class="list-unstyled mb-0 striped-list">
                    <li>
                      <div class="row">
                        <div class="col-md-5">
                          <strong class="p-2 d-inline-block">Mobile no:</strong>
                        </div>
                        <div class="col-md-7">
                          <span class="p-2 d-inline-block">1248848548548</span>
                        </div>
                      </div>
                    </li>
                    <li>
                      <div class="row">
                        <div class="col-md-5">
                          <strong class="p-2 d-inline-block">Status:</strong>
                        </div>
                        <div class="col-md-7">
                          <span class="p-2 d-inline-block text-success">
                            Whitelisted
                          </span>
                        </div>
                      </div>
                    </li>
                  </ul>
                </div>
                <div class="col-xl-4 col-md-6">
                  <ul class="list-unstyled mb-0 striped-list">
                    <li>
                      <div class="row">
                        <div class="col-md-5">
                          <strong class="p-2 d-inline-block">
                            Account no:
                          </strong>
                        </div>
                        <div class="col-md-7">
                          <span class="p-2 d-inline-block">2648575295</span>
                        </div>
                      </div>
                    </li>
                  </ul>
                </div>
              </div>
              <div class="d-flex justify-content-between align-items-end mb-2">
                <h5 class="text-primary font-weight-normal">
                  Associated Senders ({{ items.length }})
                </h5>
                <b-button
                  class="btn btn-auto"
                  variant="outline-primary"
                  v-if="searchReceivers == 'xyz'"
                >
                  Remove Receiver from Blacklist
                </b-button>
                <b-button
                  class="btn btn-auto"
                  variant="outline-primary"
                  v-else
                  @click="showAlert"
                >
                  Blacklist Receiver For All
                </b-button>
              </div>
              <!-- Table Pagination -->
              <div
                class="py-1 align-items-center justify-content-end table-pagination"
                :class="totalRows > 0 ? ' d-flex' : 'd-none'"
              >
                <div class="number-page">
                  <b-pagination
                    class="pagination-small"
                    v-model="currentPage"
                    :total-rows="totalRows"
                    first-text="First"
                    last-text="Last"
                    :per-page="perPage"
                    align="right"
                  ></b-pagination>
                </div>
              </div>
              <b-table
                responsive
                table-class="mb-0 table-custom border"
                head-variant="light"
                :items="items"
                :fields="fields"
                :current-page="currentPage"
                :per-page="perPage"
                :sort-by.sync="sortBy"
                :sort-desc.sync="sortDesc"
                :sort-direction="sortDirection"
                striped
              >
                <template #head()="{ label, field: { key } }">
                  {{ label }}
                  <template>
                    <i v-if="sortBy !== key" class=""></i>
                    <i
                      v-else-if="sortDesc"
                      class="fa fa-long-arrow-down ml-1"
                    ></i>
                    <i v-else class="fa fa-long-arrow-up ml-1"></i>
                  </template>
                </template>
                <template #cell(sender)="data">
                  <a
                    href="javascript:void(0);"
                    class="font-color"
                    @click="customerDetailModel(data.item)"
                  >
                    <span class="mr-2">{{ data.value }}</span>
                    ({{ data.item.payangel_id }})
                  </a>
                </template>
                <template #cell(last_trans_date)="data">
                  <router-link
                    class="font-color mr-2"
                    to="/transaction/details"
                    target="_blank"
                  >
                    <i
                      class="fa fa-apple font-14 mr-1"
                      aria-hidden="true"
                      v-if="data.index == 0"
                    ></i>
                    <i
                      class="fa fa-android text-success font-14 mr-1"
                      aria-hidden="true"
                      v-if="data.index == 2"
                    ></i>
                    <i
                      class="fa fa-user font-14 mr-1"
                      aria-hidden="true"
                      v-if="data.index == 3"
                    ></i>
                    <i
                      class="fa fa-globe text-info font-14 mr-1"
                      aria-hidden="true"
                      v-if="data.index == 4"
                    ></i>
                    <span>{{ data.value.date }} {{ data.value.time }}</span>
                  </router-link>
                  <span>
                    (
                    <a
                      class="font-color"
                      href="javascript:void(0);"
                      @click="transactionHistory(data.item)"
                    >
                      View History
                    </a>
                    )
                  </span>
                </template>
                <template #cell(action)>
                  <b-dropdown
                    id="dropdown-1"
                    text="Actions"
                    size="sm"
                    right
                    variant="outline-primary"
                  >
                    <b-dropdown-item></b-dropdown-item>
                  </b-dropdown>
                </template>
              </b-table>
              <!-- Table Pagination -->
              <div
                class="py-3 align-items-center justify-content-between table-pagination"
                :class="totalRows > 0 ? ' d-flex' : 'd-none'"
              >
                <div class="per-page">
                  <b-form-group
                    label="Per page"
                    label-for="per-page-select"
                    class="mb-0"
                  >
                    <b-form-select
                      id="per-page-select"
                      v-model="perPage"
                      :options="pageOptions"
                      size="sm"
                    ></b-form-select>
                  </b-form-group>
                </div>
                <div class="number-page">
                  <b-pagination
                    v-model="currentPage"
                    :total-rows="totalRows"
                    first-text="First"
                    last-text="Last"
                    :per-page="perPage"
                    align="right"
                  ></b-pagination>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <CustomerDetailsModel :customerDetail="customerDetail" />
    <main-loader :loading="isLoading"></main-loader>
  </div>
</template>
<script>
const LoaderComponent =
  require("@/components/admin/loader/LoaderComponent.vue").default;
import { mapState, mapGetters } from "vuex";
import { GET_CUSTOMER_DETAILS } from "../../../store/actions.type.js";
import CustomerDetailsModel from "../../core/CustomerDetailsModel.vue";
export default {
  name: "ReceiversBlacklistComponent",
  components: {
    BreadCrumb: () => import("@/components/BreadCrumb.vue"),
    "main-loader": LoaderComponent,
    CustomerDetailsModel,
  },
  methods: {
    transactionHistory(data) {
      let route = this.$router.resolve({
        path: "/transaction/middleware",
        query: {
          filter: "true",
          sender: data.payangel_id,
          receiver: data.payangel_id,
        },
      });
      window.open(route.href, "_blank");
    },
    customerDetailModel(item) {
      this.$store.dispatch(GET_CUSTOMER_DETAILS, item.id).then((response) => {
        if (response.status == 200) {
          const customerdetails = response.data;
          this.$bvModal.show("customer-details");
          this.customerDetail = customerdetails;
        }
      });
    },
    search() {
      if (this.searchReceivers) {
        this.displaySenders = true;
      } else {
        this.displaySenders = false;
      }
    },
    showAlert() {
      const swalWithBootstrapButtons = this.$swal.mixin({
        customClass: {
          confirmButton: "btn btn-primary btn-lg my-3",
          cancelButton: "btn btn-outline-secondary btn-lg",
        },
        buttonsStyling: false,
      });
      swalWithBootstrapButtons
        .fire({
          title: "Are you sure?",
          text: "You want to blacklist Receiver for all senders?",
          icon: "warning",
          showCancelButton: true,
          confirmButtonText: "Yes, blacklist it!",
        })
        .then((result) => {
          if (result.isConfirmed) {
            swalWithBootstrapButtons.fire(
              "Blacklisted!",
              "Receiver has been blacklisted.",
              "success",
            );
          }
        });
    },
  },
  data() {
    return {
      customerDetail: null,
      searchReceivers: "",
      displaySenders: false,
      items: [
        {
          sender: "Wade Wilson",
          payangel_id: "PA1524",
          id: "5b3e6e75-364c-4bd9-b36c-d74188afc750",
          last_trans_date: { date: "2022-11-16", time: "06:50:59" },
        },
        {
          sender: "Tony Stark",
          payangel_id: "PA1524",
          id: "5b3e6e75-364c-4bd9-b36c-d74188afc750",
          last_trans_date: { date: "1985-11-18", time: "06:50:59" },
        },
        {
          sender: "Alize Thomas",
          payangel_id: "PA1524",
          id: "5b3e6e75-364c-4bd9-b36c-d74188afc750",
          last_trans_date: { date: "1991-11-22", time: "06:50:59" },
        },
        {
          sender: "Thomas Hardy",
          payangel_id: "PA1524",
          id: "5b3e6e75-364c-4bd9-b36c-d74188afc750",
          last_trans_date: { date: "1993-11-22", time: "06:50:59" },
        },
        {
          sender: "Cliff Booth",
          payangel_id: "PA48524",
          id: "5b3e6e75-364c-4bd9-b36c-d74188afc750",
          last_trans_date: { date: "1987-11-08", time: "06:50:59" },
        },
        {
          sender: "Mark Turner",
          payangel_id: "PA1524",
          id: "5b3e6e75-364c-4bd9-b36c-d74188afc750",
          last_trans_date: { date: "1989-11-08", time: "06:50:59" },
        },
      ],

      fields: [
        {
          key: "sender",
          label: "Sender",
          sortable: true,
          thClass: "th_sortfix",
        },
        {
          key: "last_trans_date",
          label: "Last Transaction Date",
          sortable: true,
          thClass: "th_sortfix",
        },
        {
          key: "action",
          label: "Action",
          sortable: false,
          thClass: "th_sortfix text-right pr-5",
          tdClass: "text-right",
        },
        { sortable: true, sortByFormatted: true, filterByFormatted: true },
      ],

      totalRows: 1,
      currentPage: 1,
      currentPageJump: 1,
      perPage: 50,
      pageOptions: [50, 100, 150, { value: 1000, text: 1000 }],
      sortBy: "",
      sortDesc: false,
      sortDirection: "asc",
    };
  },
  mounted() {
    this.totalRows = this.items.length;
  },
  computed: {
    ...mapGetters(["isLoading"]),
    ...mapState({
      apiErrors: (state) => state.auth.errors,
    }),
  },
};
</script>
